import { render, staticRenderFns } from "./FriendlyIds.vue?vue&type=template&id=2244b2cd&scoped=true"
import script from "./FriendlyIds.vue?vue&type=script&lang=ts"
export * from "./FriendlyIds.vue?vue&type=script&lang=ts"
import style0 from "./FriendlyIds.vue?vue&type=style&index=0&id=2244b2cd&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2244b2cd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2244b2cd')) {
      api.createRecord('2244b2cd', component.options)
    } else {
      api.reload('2244b2cd', component.options)
    }
    module.hot.accept("./FriendlyIds.vue?vue&type=template&id=2244b2cd&scoped=true", function () {
      api.rerender('2244b2cd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/settings/default/FriendlyIds.vue"
export default component.exports